<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode visualizar as tarefas submetidas, além da avaliação
              dada pelos avaliadores do desafio
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                <i class="fas fa-clipboard-list mr-1"></i>
                Tarefa do desafio
              </h3>
            </div>
            <div class="card-body vld-parent" ref="task_container">
              <div class="row">
                <div class="col-lg-6">
                  <base-input label="Título da tarefa">
                    <textarea
                      disabled
                      rows="1"
                      class="form-control form-control"
                      placeholder="Digite aqui..."
                      v-model="model.task.title"
                    >
                    </textarea>
                  </base-input>
                </div>
                <div class="col-lg-6 text-center text-lg-left">
                  <base-input label="Tarefa ativa?">
                    <br />
                    <base-switch
                      disabled
                      v-bind:value="Boolean(model.task.active)"
                      @input="isNumberChangeHandler($event)"
                    />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label">Data de início</label>
                    <base-input
                      disabled
                      type="date"
                      placeholder="Data de início"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.start_date"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label">Deadline</label>
                    <base-input
                      disabled
                      type="date"
                      placeholder="Deadline"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.end_date"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 te-container-read-only">
                  <base-input label="Descrição da tarefa (opicional)">
                    <quill-editor
                      v-model="model.task.description"
                      :options="editorReadOnly"
                      disabled="disabled"
                    >
                    </quill-editor>
                  </base-input>
                </div>
                <div class="col-lg-6 te-container-read-only">
                  <base-input label="Instruções para a submissão">
                    <quill-editor
                      v-model="model.task.submit_instruction"
                      :options="editorReadOnly"
                      disabled="disabled"
                    >
                    </quill-editor>
                  </base-input>
                </div>
              </div>
              <p class="text-muted text-sm text-right" v-if="task">
                Criada em {{ formatDate(task.created_at, "L") }}. Última
                atualização em {{ formatDate(task.updated_at, "L") }}.
              </p>
              <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{ error }}</base-alert>
              </div>
              <div class="col-12 text-center" v-if="success">
                <base-alert type="success">{{ success }}</base-alert>
              </div>
            </div>
            <hr class="my-0" />
            <div class="card-body vld-parent">
              <h3 class="mb-0">
                <i class="fas fa-clipboard-list mr-1"></i>
                Resposta da tarefa
              </h3>
              <p v-if="task.submission && task.submission.length">
                <quill-editor
                  v-model="task.submission[0].submission"
                  :options="editorReadOnly"
                  disabled="disabled"
                >
                </quill-editor>
              </p>
              <p v-else class="font-weight-light text-warning">
                Tarefa ainda não submetida
              </p>
            </div>
            <div class="card-body vld-parent mt--5">
              <h4>
                Avaliação da tarefa:
                <span
                  v-if="
                    task.submission &&
                      task.submission.length &&
                      task.submission[0].evaluation_score
                  "
                  class="font-weight-light"
                >
                  {{ task.submission[0].evaluation_score }}
                  <i class="fas fa-star"></i
                ></span>
                <span v-else class="font-weight-light text-warning">
                  Tarefa ainda não avaliada</span
                >
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "tarefas_edit",
  components: {
    quillEditor
  },
  data() {
    return {
      model: {
        task: {
          title: "",
          start_date: "",
          end_date: "",
          description: "",
          submit_instruction: "",
          active: true
        }
      },
      editorEdittableDescription: {
        placeholder:
          "Descreva a tarefa (lembre-se, se necessário, você pode linkar arquivos pelo editor)"
      },
      editorEdittableInstructions: {
        placeholder:
          "Digite aqui os detalhes sobre o que o colaborador deve enviar  (lembre-se, se necessário, você pode linkar arquivos pelo editor)"
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble"
      },
      totalResponses: "",
      task: "",
      batch: "",
      error: "",
      success: "",
      modals: {
        removeConfirmation: false,
        removeError: false
      }
    };
  },
  async mounted() {
    const loaderTask = this.$loading.show({
      container: this.$refs.task_container,
      width: 90,
      height: 90
    });
    try {
      await this.loadTask();
      loaderTask.hide();
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações da tarefa"
      );
    }
  },
  methods: {
    async loadTask() {
      const {
        data: { tasks }
      } = await api.get(
        `/company/challenges/${this.$route.params.id}/teams/${this.$route.params.teamId}`
      );
      const task = tasks.find(
        task => task.id === Number(this.$route.params.taskId)
      );
      this.task = task;
      for (const key in this.model.task) {
        this.model.task[key] = task[key];
      }
      this.model.task.start_date = moment(task.start_date).format("YYYY-MM-DD");
      this.model.task.end_date = moment(task.start_date).format("YYYY-MM-DD");
    },
    async handleUpdateTask() {
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.task_container,
        width: 90,
        height: 90
      });
      try {
        const task = this.model.task;
        await api.put(
          `/batches/${this.$route.params.idBatch}/tasks/${this.task.id}`,
          task
        );
        this.$toasted.show("Tarefa atualizada com sucesso");
        this.success =
          "As informações da tarefa foram atualizadas com sucesso.";
      } catch (e) {
        const strError =
          "Ocorreu um erro ao atualizar a tarefa. Tente novamente.";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    },
    handleOpenModalremoveConfirmation() {
      this.modals.removeConfirmation = true;
    },
    async handleDeleteTask() {
      this.modals.removeError = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0
      });
      try {
        await api.delete(
          `/batches/${this.$route.params.idBatch}/tasks/${this.task.id}`
        );
        this.$toasted.show("Tarefa removida com sucesso");
        this.$router.push(`/admin/batches/${this.batch.id}/acompanhamento`);
      } catch (e) {
        const strError = "Ocorreu um erro ao remover a tarefa.";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
        this.modals.removeError = true;
      } finally {
        loader.hide();
      }
    },
    isNumberChangeHandler(event) {
      if (typeof event === "boolean") this.model.task.is_number = event;
    }
  },
  computed: {
    isValidModel() {
      const requiredFields = ["title", "status", "start_date", "instructions"];
      for (const key of requiredFields) {
        if (this.model.task[key] === "") return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: flex;
  }

  i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: middle;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}

.card-profile-image img {
  width: 110px;
  height: 110px;
  border-radius: 10%;
}
</style>
<style>
.te-container-read-only .quill-editor .ql-container,
.te-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 17rem;
  width: 100%;
}

.te-container-edditable .quill-editor .ql-container,
.te-container-edditable .quill-editor .ql-container .ql-editor {
  height: 11rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
